import clsx from 'clsx';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

//lib
import {
    EVERY_DAY,
    EVERY_MONTH,
    EVERY_QUARTER,
    EVERY_WEEK,
    EVERY_YEAR
} from '@/lib/reports/reportOptions';

const FrequencyCell = ({ value }) => {
    const { t } = useTranslation('reports');
    const status = value ? value.replace('/', '_') : 'unknown';
    return (
        <span
            className={clsx('leading-wide rounded-m px-3 py-2 text-xs', {
                'bg-icoPurple-100 text-icoPurple-400 dark:bg-icoDarkMode-purple/20':
                    status === EVERY_DAY,
                'bg-icoYellow-100 text-icoYellow-400 dark:bg-icoDarkMode-yellow/20':
                    status === EVERY_WEEK,
                'bg-icoGreen-100 text-icoGreen-400 dark:bg-icoDarkMode-green/20':
                    status === EVERY_MONTH,
                'bg-icoBlue-100 text-icoBlue-400 dark:bg-icoBlue/20': status === EVERY_QUARTER,
                'bg-icoPink-100 text-icoPink-400 dark:bg-icoDarkMode-pink/20': status === EVERY_YEAR
            })}>
            {t(`general.${status}`)}
        </span>
    );
};

FrequencyCell.propTypes = {
    value: PropTypes.string
};

export default FrequencyCell;
